<template>
  <div class="search">
    <div class="whole" ref="Parent">
      <a-dropdown :visible="visible" :getPopupContainer="() => $refs.Parent">
        <div class="input_select_view">
          <div class=" type_select">
            <div v-for="(item, index) in list" :key="index" :class="`type_text_icon ${(select === item.type) && 'active'}`" @click="setSelect(item.type, 1)">
              <i :class="`top_icon iconfont ${item.icon}`" />
              <div>{{ item.label }}</div>
            </div>
          </div>
          <a-input-search v-model="word" :placeholder="t('home.searchPlaceholder')" :enter-button="t('home.searchBtn')" @blur="debounce" @focus="focus" @change="change" @search="onSearch" />
        </div>
        <div class="dropdown_whole" slot="overlay">
          <Menu :data="technologyList" :title="t('home.techKeywords')" @click="submit" borderRight />
          <Menu :data="crossList" :title="t('home.crossKeywords')" @click="submit" />
        </div>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import Menu from './menu';
import { t } from '@/locales';
export default {
  components: { Menu },
  data() {
    return {
      select: 1,
      visible: false,
      list: [],
      cancellsTechnology: this.$FN.cancells(),
      cancellsCross: this.$FN.cancells(),
      technologyList: [],
      crossList: [],
      debounce: this.$FN.debounce(this.blur, 300),
      word: null
    }
  },
  created() {
    this.setList();
  },
  watch: {
    '$store.state.language'() {
      this.setList();
    }
  },
  methods: {
    t,
    focus() { this.setVisible() },
    blur() { this.setVisible(false) },
    setSelect(value = 1) { this.select = value },
    change() { this.getTechnology(this.word); this.getCross(this.word); },
    onSearch() {
      let keyword = this.word;
      let obj = this['list'].find(item => item.type === this.select);
      if (obj) {
        this.$FN.limitsTips({ list: [obj['skipKey']] }).then(res => {
          if (res) {
            let config = { content: t('home.searchEmptyTips') };
            if (!keyword) return this.$FN.Tips(false, config);
            let query = { type: this.select, keyword };
            this.$router.$push({ path: "/comprehensiveSearch", query });
            this.$BUS.$emit("comprehensiveSearch");
          }
        })
      };
    },
    setList() {
      let list = [
        {
          type: 1,
          labelKey: 'home.searchSynthesis',
          label: t('home.searchSynthesis'),
          icon: "icon-pes_icon_line_zonghejiansuo",
          rolesKey: "home_search_synthesis",
          skipKey: "home_search_synthesis_result"
        },
        {
          type: 5,
          labelKey: 'home.searchComparison',
          label: t('home.searchComparison'),
          icon: "icon-pes_icon_line_biduijiansuo",
          rolesKey: "home_search_comparison",
          skipKey: "home_search_comparison_result"
        },
        {
          type: 2,
          labelKey: 'home.searchId',
          label: t('home.searchId'),
          icon: "icon-pes_icon_line_bianhaojiansuo",
          rolesKey: "home_search_id",
          skipKey: "home_search_id_result"
        },
        {
          type: 3,
          labelKey: 'home.searchName',
          label: t('home.searchName'),
          icon: "icon-pes_icon_line_mingchengjiansuo",
          rolesKey: "home_search_name",
          skipKey: "home_search_name_result"
        },
        {
          type: 4,
          labelKey: 'home.searchContent',
          label: t('home.searchContent'),
          icon: "icon-pes_icon_line_neirongjiansuo",
          rolesKey: "home_search_content",
          skipKey: "home_search_content_result"
        }
      ];

      this.list = this.$FN.filterLimitsVisible({ data: list });
    },
    getTechnology(word = null) {
      let config = { method: "post", contentType: "2" };
      this.cancellsTechnology('/api/product_service/word/relate_word', { word }, config).then(res => {
        res && (this.technologyList = res.entity);
        this.setVisible();
      });
    },
    getCross(word = null) {
      let config = { method: "post", contentType: "2" };
      this.cancellsCross('/api/product_service/word/cross_language_word', { word }, config).then(res => {
        res && (this.crossList = res.entity);
        this.setVisible();
      });
    },
    setVisible(value = !!(this.technologyList.length || this.crossList.length)) { this.visible = value },
    submit(value) { this.word = value }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
